<template>
    <div class="theme_panel">
        <div class="toggle_bts" @click="setting = !setting">
            <i class="ion ion-android-settings"></i>
        </div>
        <div class="theme_menu" :class="{'active':setting}">
            <a class="buy-btn wp_btn" style="margin-top: 0;background: #248fef;">
                <i class="ion ion-hammer"></i>
                {{$t("themePenal.001")}}
            </a>
            <h4>{{$t("themePenal.002")}}</h4>
            <div class="segment">
                <ul class="theme layout_style">
                    <li v-for="(main, index) in mainColorList" :key="index">
                        <a
                            :title="'theme-'+main.name"
                            @click="setMainColor(main.name)"
                            :class="{'main-broder':main.name==mainColor}"
                            :style="{'backgroundColor':main.color }"
                        ></a>
                    </li>
                </ul>
            </div>
            <div class="clear"></div>
            <h4>{{$t("themePenal.003")}}</h4>
            <ul class="theme demo_list dark_style">
                <li style="width: 50%;" @click="setIsDark(false)" :class="{'active':!isDark}">
                    <strong>Light</strong>
                </li>
                <li style="width: 50%;" @click="setIsDark(true)" :class="{'active':isDark}">
                    <strong>Dark</strong>
                </li>
            </ul>
            <div class="clear"></div>
            <h4>{{$t("themePenal.004")}}</h4>
            <ul class="theme demo_list">
                <li
                    v-for="(lang ,index) in langTypeList"
                    :key="index"
                    @click="setLangType(lang.value)"
                    style="width: 50%;"
                    :class="{'active':langType==lang.value}"
                >
                    <strong>{{lang.name}}</strong>
                </li>
            </ul>
            <div class="clear"></div>
            <h4>{{$t("themePenal.005")}}</h4>
            <ul class="theme demo_list">
                <li
                    v-for="(ani, index) in aniList"
                    :class="{'active':pageAni==ani.effect}"
                    :key="index"
                    style="width: 50%;"
                    @click="setAni(ani.effect)"
                >
                    <strong>{{ ani.name}}</strong>
                </li>
            </ul>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    data() {
        return {
            setting: false,
            mainColorList: [
                { name: "green", color: "rgba(46, 202, 127, 1)" },
                { name: "blue", color: "rgba(8, 86, 193, 1)" },
                { name: "orange", color: "rgba(255, 152, 0, 1)" },
                { name: "pink", color: "rgba(255, 94, 148, 1)" },
                { name: "purple", color: "rgba(196, 70, 218, 1)" },
                { name: "red", color: "rgba(232, 103, 107, 1)" }
            ],
            langTypeList: [{ name: "繁中", value: "tw" }, { name: "简中", value: "cn" }, { name: "English", value: "en" }]
        };
    },
    computed: {
        ...mapState(["pageAni", "mainColor", "isDark", "langType"]),
        aniList() {
            return [
                { effect: "rotate", name: this.$t("themePenal.006") },
                { effect: "slide", name: this.$t("themePenal.007") },
                { effect: "flip", name: this.$t("themePenal.008") },
                { effect: "roll", name: this.$t("themePenal.009") },
                { effect: "fade", name: this.$t("themePenal.010") }
            ];
        }
    },
    methods: {
        ...mapMutations(["setAni", "setMainColor", "setIsDark", "setLangType"])
    }
};
</script>

<style lang="scss" scoped>
li {
    cursor: pointer;
}
.main-broder {
    border: solid 4px #bbb;
}
</style>


// WEBPACK FOOTER //
// src/components/themePenal.vue